import { createFileRoute } from '@tanstack/react-router';

import { ResourceDetailPage } from './ResourceDetailPage';

export const Route = createFileRoute('/_protected/_consumer/resources/$programId/')({
  component: ResourceDetailPage,
});
